import { Box } from '@mui/material'
import { Link } from '@assets-components'
import { Image } from '@media-components'
import { CustomStyles, getStyles } from '@utils/styles'
import { CardData } from '../DefaultCard'
import defaultStyles, { StyleClassNames } from './styles'

export type ImageCardData = CardData

type ImageCardProps = ImageCardData & {
  csx?: CustomStyles<StyleClassNames>
}

export function ImageCard({
  imageData,
  actionButtonData,
  csx,
}: ImageCardProps) {
  const styles = getStyles(defaultStyles, csx)

  return (
    <Box
      component={Link}
      href={actionButtonData?.link || '#'}
      {...styles('wrapper')}
    >
      {imageData && <Image {...imageData} {...styles('image')} />}
      {/* <Typography variant="body1.500" color="text.secondaryDark">
        {title}
      </Typography>
      {description && (
        <Typography variant="caption1.500" color="grey.600">
          {description}
        </Typography>
      )} */}
    </Box>
  )
}
